import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DataContext } from '@services/data-context';
import { MessageService } from '@services/messages';
import { ProjectAccessService } from './project-access.service';

export const hasClientAccessGuard: CanActivateFn = (route) => {
  const dataContext = inject(DataContext);
  const projectAccess = inject(ProjectAccessService);
  const router = inject(Router);
  const message = inject(MessageService);
  const translate = inject(TranslateService);

  const projectId = route.paramMap.get('projectId') ?? '';
  const projectContext = dataContext.matchProjectContext(projectId);

  if (projectContext) {
    if (projectContext.hasClientAccess()) {
      void resolveAccessAsync();
      return true;
    }

    denyAccess();
    return false;
  }

  return resolveAccessAsync();

  async function resolveAccessAsync(): Promise<boolean> {
    await projectAccess.loadProjectDetailsAsync(projectId);
    await projectAccess.loadCompanyAccessAsync(projectId);

    if (!dataContext.isRequestedProject(projectId)) {
      return false;
    }

    const context = dataContext.projectContext();
    if (!context || !context.project()) {
      message.showErrorMessage(translate.instant('general.projectLoadFailed'));
      void router.navigate(['/projects']);
      return false;
    }

    if (context.hasClientAccess()) {
      return true;
    }

    denyAccess();
    return false;
  }

  function denyAccess(): void {
    message.showErrorMessage(translate.instant('general.noCompanyError'));
    void router.navigate(['/projects']);
  }
};
